import { render, staticRenderFns } from "./loginReg.vue?vue&type=template&id=2f6c26d4&scoped=true&"
import script from "./loginReg.vue?vue&type=script&lang=js&"
export * from "./loginReg.vue?vue&type=script&lang=js&"
import style0 from "./loginReg.vue?vue&type=style&index=0&id=2f6c26d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c26d4",
  null
  
)

export default component.exports